import {
  useQuery,
} from '@tanstack/react-query'
import { useAuth } from 'react-oidc-context';
import { IWarehouse } from './types';

export function useWarehouses() {
  const auth = useAuth();

  return useQuery({
    queryKey: ['warehouses'],
    queryFn: () =>
      fetch(`/api/warehouses`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.user?.id_token}`,
        },
      }).then((res) =>
        res.json() as  Promise<{items:IWarehouse[]}>,
      ),
    enabled: auth.isAuthenticated && auth.user?.id_token !== undefined
  });
}